import {JqueryApp} from "./src/JqueryApp";

let jqApp = new JqueryApp(jQuery);
// export it so that the API is accessible to other libraries
// this is optional
(window as any).promptCash = jqApp;
